import { AccredibleAttributeTypes } from '@accredible-frontend-v2/models';

export interface DefaultAttribute {
  parent: string;
  key: string;
  type: AccredibleAttributeTypes;
}

export const DEFAULT_ATTRIBUTES: Partial<DefaultAttribute>[] = [
  // Issuer Defaults
  { parent: 'issuer', key: 'name', type: AccredibleAttributeTypes.TEXT },
  // Group Defaults
  { parent: 'group', key: 'course_name', type: AccredibleAttributeTypes.TEXT },
  { parent: 'group', key: 'course_description', type: AccredibleAttributeTypes.TEXT },
  // Credential Defaults
  { parent: 'credential', key: 'id', type: AccredibleAttributeTypes.TEXT },
  { parent: 'credential', key: 'license_id', type: AccredibleAttributeTypes.TEXT },
  { parent: 'credential', key: 'issued_on', type: AccredibleAttributeTypes.DATE },
  { parent: 'credential', key: 'expired_on', type: AccredibleAttributeTypes.DATE },
  { parent: 'credential', key: 'grade', type: AccredibleAttributeTypes.TEXT },
  { parent: 'credential', key: 'url', type: AccredibleAttributeTypes.TEXT },
  { parent: 'credential', key: 'uuid', type: AccredibleAttributeTypes.TEXT },
  // Recipient Defaults
  { parent: 'recipient', key: 'id', type: AccredibleAttributeTypes.TEXT },
  { parent: 'recipient', key: 'name', type: AccredibleAttributeTypes.TEXT },
  { parent: 'recipient', key: 'email', type: AccredibleAttributeTypes.EMAIL },
];
